import { BaseProxy } from "@/proxies/BaseProxy";

export class ProjectPlansProxy  extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `projectPlans`,
      parameters,
    });
  }
}
 